import { Component } from "react"
import PropTypes from "prop-types"
import { StatusRow } from "./table_components"

const STENCIL_NAMES = {
  mobile: "Notification",
  message: "Text",
  title: "Title",
  tags: "Tags",
  html: "Body",
  folder: "Folder path",
  filename: "Filename",
  body: "Text body",
  collection_title: "Spreadsheet name",
  spreadsheet: "Formatted row",
  spoken: "Message to say",
  calendar: "Quick add text",
}

export default class AppletDefault extends Component {
  render() {
    const { stencil } = this.props
    return (
      <table className="subtable">
        <tbody>
          {this.props.diffStyle !== "none" && (
            <StatusRow status={stencil.status} />
          )}
          {this.props.tableRow({
            key: `applet-default-group-${stencil.fields[0].slug}-${stencil.fields[0].id}`,
            name: "Applet Default",
            value: stencil.title,
            noFeedbackAllowed: true,
          })}
          {this.props.stencil.fields.map(field =>
            this.props.tableRow({
              key: `applet-default-item-${field.slug}-${field.id}`,
              name: STENCIL_NAMES[field.slug],
              value: field.value,
              diff: field.changes.find(diff => diff.path[4] === field.id),
              required: true,
              feedback: field.feedback,
              pathObjs: [...this.props.pathObjs, field.id],
            })
          )}
        </tbody>
      </table>
    )
  }
}

AppletDefault.propTypes = {
  diffStyle: PropTypes.string,
  stencil: PropTypes.shape({
    title: PropTypes.string.isRequired,
    status: PropTypes.oneOf(["new", "deleted", "updated", "stale"]).isRequired,
    fields: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.oneOf(["new", "deleted", "updated", "stale"])
          .isRequired,
        changes: PropTypes.array.isRequired,
        feedback: PropTypes.array,
      })
    ),
  }).isRequired,
  pathObjs: PropTypes.array.isRequired,
  tableRow: PropTypes.func.isRequired,
}
